import script from "./PaymentInvoiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentInvoiceView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentInvoiceView.vue?vue&type=style&index=0&id=e84f9a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e84f9a84"]])

export default __exports__